import { NotificationType, notifyUser } from './notificationHelper';
import { ImageFileDto } from '@emutabakat-types/app';

export const base64ToArrayBuffer = (base64: string) => {
  const binary_string = window.atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes.buffer;
};

export const getNonImageFileThumbnail = (fileContentType: string) => {
  switch (fileContentType) {
    // TODO: Dosya tiplerine göre logolar buraya eklenecek.
    case 'application/pdf':
      return '/assets/images/pdf-logo.png';
    case 'application/msword':
      return '/assets/images/microsoft-word-logo.png';
    default:
      return '';
  }
};

export const validateFileSize = (file: File) => {
  const maxFileSize = 40 * 1024 * 1024;
  if (file.size <= maxFileSize) {
    return true;
  }
  notifyUser(
    NotificationType.error,
    'Dosya boyutu hatası',
    "Maksimum dosya boyutu 40 MB'tan küçük olmalıdır."
  );
  return false;
};

export const isImageFile = (fileContentType: string) => {
  if (fileContentType.indexOf('image/') >= 0) {
    return true;
  }
  return false;
};

export const getImageUrl = (imageFile: ImageFileDto) => {
  const blob = new Blob(
    [base64ToArrayBuffer(imageFile.fileContent) as BlobPart],
    {
      type: imageFile.fileContentType
    }
  );
  const blobUrl = URL.createObjectURL(blob);
  return blobUrl;
};
